import { useState, useEffect } from 'react';
import { parseUrlParams, extractDomain, siteUrlFromPageUrl } from './popupUtils';

export const usePopupState = (isReady) => {
    const [initializing, setInitializing] = useState(true);
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [domain, setDomain] = useState('');
    const [loading, setLoading] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [editingAlias, setEditingAlias] = useState(null);
    
    // Form state
    const [siteName, setSiteName] = useState('');
    const [siteUrl, setSiteUrl] = useState('');
    const [privateNotes, setPrivateNotes] = useState('');
    const [alertsEnabled, setAlertsEnabled] = useState(true);
    const [hidden, setHidden] = useState(false);
    const [handleSpamBy, setHandleSpamBy] = useState(-1);
    const [creating, setCreating] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const params = parseUrlParams();
        const urlParam = params.url;
        const titleParam = params.title;
        
        setUrl(urlParam);
        setTitle(titleParam);
        setSiteUrl(siteUrlFromPageUrl(urlParam));
        setSiteName(titleParam || extractDomain(urlParam));
        setDomain(extractDomain(urlParam));
        
        if (isReady) {
            setInitializing(false);
        }
    }, [isReady]);

    const resetForm = (user) => {
        setSiteName(title || extractDomain(url));
        setSiteUrl(siteUrlFromPageUrl(url));
        setPrivateNotes('');
        setAlertsEnabled(true);
        setHidden(false);
        setHandleSpamBy(-1);
    };

    const startEditAlias = (alias) => {
        setEditingAlias(alias);
        setSiteName(alias.site_name);
        setSiteUrl(alias.custom_url || alias.site_url);
        setPrivateNotes(alias.private_notes || '');
        setAlertsEnabled(alias.alerts_enabled);
        setHidden(alias.hidden);
        setHandleSpamBy(alias.blacklist_action !== undefined ? alias.blacklist_action : -1);
        setShowEditForm(true);
    };

    const cancelEdit = () => {
        setShowEditForm(false);
        setEditingAlias(null);
    };

    return {
        // Basic state
        initializing,
        url,
        title,
        domain,
        loading,
        setLoading,
        
        // View state
        showCreateForm,
        setShowCreateForm,
        showEditForm,
        setShowEditForm,
        editingAlias,
        
        // Form state
        siteName,
        setSiteName,
        siteUrl,
        setSiteUrl,
        privateNotes,
        setPrivateNotes,
        alertsEnabled,
        setAlertsEnabled,
        hidden,
        setHidden,
        handleSpamBy,
        setHandleSpamBy,
        creating,
        setCreating,
        saving,
        setSaving,
        
        // Actions
        resetForm,
        startEditAlias,
        cancelEdit
    };
};